import React, { useRef, useState } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import calender from "../../../../assets/calendar.png";

const today = new Date();
today.setHours(0, 0, 0, 0);

const formatWeekDay = (date) =>
  date.toLocaleDateString("en-US", { weekday: "short" });

const generateDates = (centerDate, daysBefore = 3, daysAfter = 5) => {
  const dates = [];
  const start = new Date(centerDate);
  start.setDate(centerDate.getDate() - daysBefore);
  if (start < today) start.setTime(today.getTime());

  const totalDays = daysBefore + daysAfter + 1;
  for (let i = 0; i < totalDays; i++) {
    const d = new Date(start);
    d.setDate(start.getDate() + i);
    dates.push({ day: d, label: formatWeekDay(d) });
  }

  return dates;
};

const DateSelect = ({ fetchVenueSlotsList, selectedDate, setSelectedDate }) => {
  const buttonRef = useRef(null);

  const dates = generateDates(selectedDate);
  return (
    <div className="">
      {/* Header */}
      <div className="flex flex-col sm:flex-row justify-between mb-2 items-start sm:items-center">
        <h1 className="text-2xl font-semibold text-gray-800 mb-2 sm:mb-0">
          Available Time Slot
        </h1>
        <span className="text-gray-500">
          {selectedDate.toLocaleDateString("en-US", {
            month: "short",
            year: "numeric",
          })}
        </span>
      </div>

      {/* Date Selector - Scrollable */}
      <div className="flex items-center gap-2 justify-center">
        <div className="w-xl overflow-x-auto scrollbar-hide thin-scrollbar flex items-center gap-2 py-2">
          {dates.map((date) => (
            <button
              key={date.day.toISOString()}
              onClick={() => {
                fetchVenueSlotsList(date?.day);
                setSelectedDate(date?.day);
              }}
              className={`flex-shrink-0 md:px-10 px-6 py-2 rounded-lg font-medium text-sm sm:text-base
              ${
                selectedDate.toDateString() === date.day.toDateString()
                  ? "bg-sky-500 text-white"
                  : "bg-gray-100 text-gray-600 hover:bg-gray-200"
              }`}
            >
              <p>{date.label}</p>
              <p> {date.day.getDate()}</p>
            </button>
          ))}
        </div>

        {/* Calendar Icon / DatePicker */}
        <div className="md:w-3xs w-24">
          <DatePicker
            minDate={today}
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            customInput={
              <button
                ref={buttonRef}
                className="flex-shrink-0 md:px-6 md:py-5 rounded-lg bg-gray-100 hover:bg-gray-200 text-lg"
              >
                <img src={calender} alt="Calender" className="w-50" />
              </button>
            }
          />
        </div>
      </div>
    </div>
  );
};

export default DateSelect;
